<template>
  <div id="landing-page">
    <div class="landing-header">
      <div class="landing-header-wrapper">
        <div class="inner">
          <div class="landing-header__title mr-sm-8">
            <h1>EASI score</h1>
            <p>
              {{ $t("landing_page_intro") }}
            </p>
            <p>{{ $t("landing_page_registration_intro") }}</p>
            <div class="d-flex flex-column flex-sm-row">
              <v-btn
                class="secondary-btn mr-sm-4"
                :to="{ name: 'kalkulator' }"
                >{{ $t("enter_without_registration") }}</v-btn
              >
            </div>
          </div>
          <div
            id="registration-card"
            class="landing-header__registration-card mx-auto"
          >
            <h2>{{ $t("registration") }}</h2>
            <div id="login-message" v-if="serverErrors.length > 0">
              <div v-for="(error, index) in serverErrors" :key="index">
                {{ error.message }}
              </div>
            </div>
            <v-form
              ref="form"
              v-model="isRegistrationFormValid"
              @submit.prevent="onSubmit"
            >
              <v-text-field
                v-model="doctor.user.email"
                :rules="[rules.required, rules.email]"
                outlined
                dense
                label="Email"
              />
              <v-text-field
                v-model="doctor.password"
                :rules="[rules.required, rules.minLength]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                class="my-1"
                outlined
                dense
                label="Heslo"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="confirmPassword"
                :rules="[
                  rules.required,
                  rules.minLength,
                  rules.sameAs(confirmPassword, doctor.password),
                ]"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showConfirmPassword ? 'text' : 'password'"
                class="my-1"
                outlined
                dense
                :label="$t('confirm_password')"
                @click:append="showConfirmPassword = !showConfirmPassword"
              />
              <v-btn
                class="registration-btn"
                type="submit"
                color="#F6990C"
                dark
                >{{ $t("registrate") }}</v-btn
              >
            </v-form>
          </div>
        </div>
      </div>
      <div class="arrow" @click="scrollTo('landing-body')">
        <div class="arrow__text">{{ $t("more_information") }}</div>
        <div class="arrow__icon">
          <i class="fal fa-arrow-circle-down"></i>
        </div>
      </div>
    </div>

    <div class="landing-body">
      <div class="body-section">
        <div class="body-section__text">
          <h1>1) {{ $t("langing_page_easi_calculator_title") }}</h1>
          {{ $t("langing_page_easi_calculator_text") }}
        </div>
        <div class="body-section__img">
          <img src="https://general-storage.b-cdn.net/image24L.gif" alt="" />
        </div>
      </div>
      <div class="body-section">
        <div class="body-section__img">
          <img src="https://general-storage.b-cdn.net/image25L.gif" alt="" />
        </div>
        <div class="body-section__text">
          <h1>2) {{ $t("langing_page_easi_saving_data_title") }}</h1>
          {{ $t("langing_page_easi_saving_data_text") }}
        </div>
      </div>
      <div class="body-section">
        <div class="body-section__text">
          <h1>3) {{ $t("langing_page_easi_report_title") }}</h1>
          {{ $t("langing_page_easi_report_text") }}
        </div>
        <div class="body-section__img">
          <img src="https://general-storage.b-cdn.net/image26L.gif" alt="" />
        </div>
      </div>
      <div class="body-section">
        <div class="body-section__img">
          <img src="https://general-storage.b-cdn.net/image27L.gif" alt="" />
        </div>
        <div class="body-section__text">
          <h1>4) {{ $t("langing_page_easi_charts_title") }}</h1>
          {{ $t("langing_page_easi_charts_text") }}
        </div>
      </div>
      <div class="body-section">
        <div class="body-section__text">
          <h1>5) {{ $t("landing_page_easi_adding_visit_title") }}</h1>
          {{ $t("landing_page_easi_adding_visit_text") }}
        </div>
        <div class="body-section__img">
          <img src="https://general-storage.b-cdn.net/image28L.gif" alt="" />
        </div>
      </div>
      <div class="body-section">
        <div class="body-section__img">
          <img
            src="https://general-storage.b-cdn.net/EASI_ukladani_fotek.gif"
            alt=""
          />
        </div>
        <div class="body-section__text">
          <h1>6) {{ $t("landing_page_saving_photos_title") }}</h1>
          {{ $t("landing_page_saving_photos_text") }}
        </div>
      </div>
    </div>
    <div class="landing-footer">
      <div class="landing-footer__section mr-8 mb-8 mb-lg-0">
        <h1>{{ $t("registration") }}</h1>
        <p>
          {{ $t("landing_page_registration_footer") }}
        </p>
        <v-btn depressed color="#F6990C" dark :href="'#registration-card'">{{
          $t("app_registration")
        }}</v-btn>

        <div class="mt-4">
          <a
            class="white--text"
            href="https://easi-score.b-cdn.net/EASIscore_Podmínky_užití_1.0%20(1).pdf"
            target="_blank"
          >
            Stránky jsou určeny výhradně odborníkům ve zdravotnictví
          </a>
        </div>
      </div>
      <div class="landing-footer__section mr-8 mb-8 mb-lg-0">
        <h1>{{ $t("mobile_app") }}</h1>
        <div class="qr-codes">
          <div>
            <div>Apple</div>
            <img src="../assets/easi-score-ios.png" alt="" />
          </div>
          <div>
            <div>Android</div>
            <img src="../assets/easis-score-android.png" alt="" />
          </div>
        </div>
      </div>
      <div class="landing-footer__section mr-8 mb-8 mb-lg-0">
        <div class="mt-4">
          <div>Sponzoři projektu nenesou odpovědnost za obsah stránky</div>
          <div>
            Autor a provozovatel projektu je
            <a
              class="white--text"
              href="https://www.tmesolutions.cz/"
              target="_blank"
              rel="noopener noreferrer"
              >TME solutions s. r. o.</a
            >
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $t("confirmation_email_title")
        }}</v-card-title>
        <v-card-text>
          <p>
            {{ $t("confirmation_email_text") }}
          </p>
          <p>{{ $t("confirmation_email_text1") }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#324c8d" text @click="showDialog = false">{{
            $t("close")
          }}</v-btn>
          <v-btn
            color="#324c8d"
            text
            @click="$router.push({ name: 'prihlaseni' })"
          >
            {{ $t("login_text") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "landing-page",
  data() {
    return {
      doctor: {
        user: { email: "" },
        password: "",
      },
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      showDialog: false,
      serverErrors: [],
      isRegistrationFormValid: true,
      rules: {
        required: (value) => !!value || this.$t("validate_required"),
        minLength: (value) =>
          value.length >= 6 || this.$t("validate_pass_length"),
        sameAs: (value, password) =>
          value === password || this.$t("validate_pass_same"),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("validate_email");
        },
      },
    };
  },
  methods: {
    scrollTo(element) {
      const el = document.querySelector(`.${element}`);
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    async registerUser() {
      try {
        await this.$http.post("doctors", this.doctor);
        this.showDialog = true;
      } catch (error) {
        if (error.status >= 500) {
          // eslint-disable-next-line no-console
          console.error("Server error");
        } else {
          this.serverErrors = error.data.errors;
        }
      }
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.isRegistrationFormValid) {
        this.registerUser();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-page {
  overflow-x: hidden;
  position: relative;
  #login-message {
    padding: 1rem 0.7rem;
    font-size: 0.9rem;
    background: rgb(253, 192, 192);
    margin-bottom: 2rem;
  }
  .landing-header {
    min-height: 100vh;
    position: relative;
    margin-bottom: 3rem;

    @media screen and (min-width: 768px) {
      margin-bottom: 7rem;
    }
    .landing-header-wrapper {
      background-color: #324c8d;
      padding: 3rem 2rem 6rem;
      height: 100%;
      @media screen and (min-width: 768px) {
        background: url("../assets/easi-bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        padding: 12rem 2rem;
      }
      .inner {
        margin: auto;
        max-width: 80rem;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: 768px) {
          flex-direction: row;
        }
      }

      @media screen and (min-width: 1921px) {
        padding: 15rem 2rem;
      }
    }

    .landing-header__title {
      width: 100%;
      margin-bottom: 2rem;

      h1 {
        color: white;
        font-size: 2rem;
        font-weight: 400;
        margin-bottom: 1rem;
        @media screen and (min-width: 768px) {
          margin-bottom: 2rem;
          font-size: 4rem;
        }
      }

      p {
        color: white;
        font-size: 1rem;
        max-width: 45rem;
        font-weight: 300;
        @media screen and (min-width: 768px) {
          font-size: 1.5rem;
        }
      }

      .secondary-btn {
        margin-top: 2rem;
        font-size: 1rem;
        height: 3rem;
      }
    }

    .landing-header__registration-card {
      background: white;
      right: 30rem;
      padding: 2rem;
      width: 100%;
      max-width: 25rem;
      box-shadow: rgba(149, 157, 165, 0.5) 0px 8px 24px;
      transition: box-shadow 0.4s ease-in-out;

      &:hover {
        box-shadow: rgba(22, 4, 121, 0.568) 0px 5px 15px;
      }

      .v-btn {
        width: 100%;
        height: 3rem;
        font-size: 1rem;
      }

      h2 {
        margin-bottom: 1rem;
        font-size: 2rem;
        color: rgb(46, 46, 46);
      }
    }
  }

  .arrow {
    text-align: center;
    cursor: pointer;
    color: rgb(78, 78, 78);
    margin: auto;
    margin-top: 1rem;
    max-width: 9rem;

    .arrow__text {
      font-size: 1.2rem;
      margin-bottom: 2rem;
    }

    .arrow__icon {
      font-size: 2rem;
      animation: bounce 0.8s infinite alternate;
      -webkit-animation: bounce 0.8s infinite alternate;
    }

    @keyframes bounce {
      from {
        transform: translateY(0px);
      }
      to {
        transform: translateY(-10px);
      }
    }
    @-webkit-keyframes bounce {
      from {
        transform: translateY(0px);
      }
      to {
        transform: translateY(-10px);
      }
    }
  }

  .landing-body {
    padding: 2rem;
    @media screen and (min-width: 1280px) {
      padding: 10rem;
    }
    .body-section {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6rem;
      flex-direction: column;

      .body-section__img {
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        margin-bottom: 2rem;
        order: 0;
        img {
          width: 100%;
        }
      }
      .body-section__text {
        order: 1;
        h1 {
          margin-bottom: 1rem;
        }
      }
      @media screen and (min-width: 768px) {
        margin-bottom: 12rem;
        flex-direction: row;
        .body-section__img {
          width: 60%;
          order: unset;
        }
        .body-section__text {
          width: 35%;
          order: unset;
        }
      }
    }
  }

  .landing-footer {
    background: rgb(58, 58, 58);
    padding: 2rem;
    display: flex;
    color: white;
    font-size: 1rem;
    flex-direction: column;
    @media screen and (min-width: 1300px) {
      flex-direction: row;
      justify-content: space-between;
    }
    @media screen and (min-width: 1400px) {
      padding: 4rem 10rem;
    }
    h1 {
      font-size: 2rem;
      margin-bottom: 1rem;
      font-weight: 400;
    }

    .landing-footer__section {
      max-width: 100%;

      .partner-logo {
        max-width: 15rem;
        border-radius: 0.5rem;
        @media screen and (min-width: 768px) {
          max-width: 17rem;
        }
      }

      .partner-logo-small {
        max-width: 15rem;
        border-radius: 0.5rem;
        @media screen and (min-width: 768px) {
          max-width: 15rem;
        }
      }

      .qr-codes {
        max-width: 100%;
        display: flex;
        flex-direction: column;

        img {
          max-width: 5rem;
          margin-right: 3rem;
          margin-top: 0.5rem;
        }

        @media screen and (min-width: 768px) {
          flex-direction: row;
          max-width: 23%;
        }
      }
    }
  }
}
</style>
